import { Breakpoint } from "antd";
import { create } from "zustand";

interface ScreenState {
  screens: Partial<Record<Breakpoint, boolean>>;
  setScreens: (screens: Partial<Record<Breakpoint, boolean>>) => void;
}

export const useScreenStore = create<ScreenState>((set) => ({
  screens: {},
  setScreens: (screens) => set({ screens }),
}));
